import axios from 'axios';
import { BASE_URL } from '../config/config';

const URL = BASE_URL + '/inquiry';
const getInquiry = async () => {
  try {
    const response = await axios.get(URL);
    return response.data;
  } catch (error) {
    console.error('Get Inquiry Error:', error);
    throw error; // ⬅️ penting
  }
};

export { getInquiry };
